export default __webpack_public_path__ + "static/media/pic7.cc6cf04c.jpg";